module.exports = __webpack_public_path__ + "fonts/Nunito-400-cyrillic2.166e8e8.woff2";